/**
 * Fullscreen banner offset.
 *
 * Measures how much sits above the fullscreen banner (announcement bar +
 * header) and exposes it as --banner-offset, so the banner can fill exactly
 * the remaining viewport height: calc(100svh - var(--banner-offset)).
 *
 * Measuring the banner's own distance from the top of the document (at scroll
 * 0) is the most reliable way to capture whatever is stacked above it, no
 * matter the announcement-bar / header heights.
 */
(function () {
  function updateBannerOffset() {
    const banner = document.querySelector('.banner--fullscreen');
    if (!banner) return;

    // Distance from the document top = combined height of everything above.
    const offset = banner.getBoundingClientRect().top + window.pageYOffset;
    banner.style.setProperty('--banner-offset', `${Math.max(0, Math.round(offset))}px`);
  }

  function init() {
    updateBannerOffset();

    // Recalculate on resize (debounced) and after fonts/images settle.
    let timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(updateBannerOffset, 150);
    });
    window.addEventListener('load', updateBannerOffset);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
